<div class="visit-list-container">
  <h3 class="visit-header">Other Scheduled Work</h3>

  @if (visits && visits.length > 0) {
  <div class="visit-list">
    @for (visit of visits; track visit) {
    <div class="visit-item"
      [matTooltip]="'Job: ' + visit.job?.externalJobReference + ' - ' + (visit.visitType?.description || 'Visit') + ' - Priority: ' + visit.job?.priority?.description">
      <div class="visit-time">
        <span class="date-badge">{{ visit.appointmentEnd | amDateFormat: "DD/MM/yyyy" }}</span>

        @if (visit.visitStatus === 'FLOATING') {
        <span class="time-text floating-booking">
          <mat-icon fontIcon="fa-calendar-week" fontSet="far"></mat-icon>
          Floating: {{ visit.appointmentStart | amDateFormat: "DD/MM/yyyy" }} - {{ visit.appointmentEnd | amDateFormat:
          "DD/MM/yyyy" }}
        </span>
        } @else {
        <span class="time-text">{{ visit.appointmentStart | amDateFormat: "HH:mm" }} - {{ visit.appointmentEnd |
          amDateFormat: "HH:mm" }}</span>
        }
      </div>

      @if (visit.job) {
      <div class="visit-detail">
        <span class="job-ref-label">Job Ref:</span>
        <span class="job-ref-value">{{ visit.job.externalJobReference }}</span>
      </div>
      }

      @if (visit.job) {
      <div class="visit-detail">
        <span class="priority-label">Priority:</span>
        <span class="priority-value"
          [ngClass]="{'high-priority': visit.job.priority.description.toLowerCase() === 'high priority'}">
          {{ visit.job.priority.description }}
        </span>
      </div>
      }

      @if (visit.visitType) {
      <div class="visit-detail">
        <span class="visit-type-label">Visit Type:</span>
        <span class="visit-type-value">{{ visit.visitType.description }}</span>
      </div>
      }

      <div class="item-divider"></div>
    </div>
    }
  </div>
  }

  @if (visits && visits.length === 0) {
  <div class="empty-list">
    <p>No other visits are currently scheduled at this property</p>
  </div>
  }

  @if (!visits) {
  <div class="loading-container">
    <mat-progress-spinner diameter="32" mode="indeterminate">
    </mat-progress-spinner>
    <p>Loading...</p>
  </div>
  }
</div>